/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'client' implicitly has an 'any' type.
export default function getCachedData(client, options = {}) {
  // @ts-expect-error TS(2339) FIXME: Property 'query' does not exist on type '{}'.
  if (!options.query) return null

  try {
    return client.readQuery(options)
  } catch (e) {
    return null
  }
}
